import React from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaLinkedin } from "react-icons/fa";
import {
  HiMail,
  HiPhone,
  HiLocationMarker,
  HiArrowRight,
} from "react-icons/hi";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-slate-900 text-slate-300 pt-20 mt-20">
      <div className="container mx-auto px-4 lg:w-4/5 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3 group">
              <span className="text-xl font-bold tracking-tight text-white">
                Prastab Dhakal
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-slate-400">
              Building Solutions for Bright humanity!
            </p>
            <div className="flex gap-3 flex-wrap">
              <a
                href="mailto:dhakalprastab@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                title="Email"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-emerald-600 hover:text-white transition-all duration-300"
              >
                <FaEnvelope size={18} />
              </a>
              <a
                href="https://www.linkedin.com/in/prastab-dhakal/"
                target="_blank"
                rel="noopener noreferrer"
                title="LinkedIn"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-red-600 hover:text-white transition-all duration-300"
              >
                <FaLinkedin size={18} />
              </a>
            </div>
          </div>

          {/* Explore Section */}
          <div className="md:text-center">
            <h3 className="text-white font-bold text-lg mb-6">Explore</h3>
            <ul className="space-y-4 inline-block text-left">
              {[
                { label: "About Us", path: "/" },
                { label: "Services", path: "/homeServices" },
                { label: "Blogs", path: "/blogs" },
                { label: "Portfolio", path: "/portfolio" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-blue-500 hover:translate-x-1 inline-flex items-center gap-2 transition-all duration-200"
                  >
                    <HiArrowRight className="text-blue-500" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-slate-800 py-8">
        <div className="container mx-auto px-4 lg:w-4/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-slate-500 text-center">
            © {currentYear} Prastab Dhakal
          </p>
          {/* <div className="flex gap-6 text-xs text-slate-500">
            <Link to="/" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/" className="hover:text-white transition-colors">
              Terms of Service
            </Link>
          </div> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
